export default {
  SET_BOOKING_STATUSES(state, payload) {
    state.bookingStatuses = payload;
  },
};
